import {Injectable} from '@angular/core';
import {FirebaseAnalytics} from '@ionic-native/firebase-analytics/ngx';
import {Platform} from '@ionic/angular';
import {UserService} from './user.service';
import * as firebase from 'firebase/app';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import {environment} from '../../environments/environment';
import {Analytics, logEvent} from '@firebase/analytics';

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {

    firebaseApp: firebase.FirebaseApp = null;
    firebaseAnalyticsWebsite: Analytics = null;

    constructor(
        private platform: Platform,
        private firebaseAnalytics: FirebaseAnalytics,
        private userService: UserService,
    ) {
        // if (environment.platform === 'website') {
        //     this.firebaseApp = initializeApp(environment.firebaseConfig);
        //     this.firebaseAnalyticsWebsite = getAnalytics();
        // }
    }

    // Tracks an 'screen_view' event in Firebase Analytics
    trackView(screenName: string) {
        // if (environment.platform === 'website') {
        //     // this.firebaseAnalyticsWebsite.setCurrentScreen(screenName);
        //
        //     const eventParams = {
        //         app_name: 'Learning Journey',
        //         screen_name: screenName
        //     };
        //     // @ts-ignore
        //     logEvent(this.firebaseAnalyticsWebsite, 'screen_view', eventParams);
        // } else {
        //     this.platform.ready().then(() => {
        //         this.firebaseAnalytics.setCurrentScreen(screenName);
        //     });
        // }
    }

    // Tracks a custom event in Firebase Analytics
    trackEvent(eventName: string, eventParams: any) {
        // let delegateParams = {};
        //
        // if (!!this.userService.userInfo) {
        //     delegateParams = {
        //         delegate_id: this.userService.userInfo.id,
        //         delegate_fullname: this.userService.userInfo.full_name,
        //         delegate_company: !!this.userService.userInfo.company ? this.userService.userInfo.company.name : null,
        //         delegate_journey: !!this.userService.userInfo.template ? this.userService.userInfo.template.name : null,
        //     };
        // }
        //
        // if (environment.platform === 'website') {
        //     logEvent(this.firebaseAnalyticsWebsite, eventName, Object.assign({}, eventParams, delegateParams));
        // } else {
        //     this.platform.ready().then(() => {
        //         this.firebaseAnalytics.logEvent(eventName, Object.assign({}, eventParams, delegateParams));
        //     });
        // }
    }
}
